<template>
    <div class="loading-box" role="status" aria-label="loading">
        <div class="loading-anim" aria-hidden="true"></div>
        <div
            class="loading-text"
            aria-hidden="true"
            :label="$t('common:loading')"
        ></div>
    </div>
</template>

<style lang="scss">
.loading-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    .loading-anim {
        position: relative;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        border: 5px solid #e9e9e9;
        background-color: transparent;
        border-right-color: #59aefc;
        animation-delay: 0s;
        -webkit-animation-delay: 0s;
        animation: loading 2s infinite linear;
        -webkit-animation: loading 2s infinite linear;
    }

    .loading-text {
        margin-top: 10px;
        width: 100px;
        height: 30px;
        font-size: 16px;
        text-align: center;
        color: rgb(160, 163, 175);
        &::before {
            content: 'Loading';
            content: attr(label);
        }
    }
}

@keyframes loading {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
@-webkit-keyframes loading {
    0% {
        -webkit-transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(360deg);
    }
}
</style>
